import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  leftValue?: string;
  topValue?: string;
}

export const Root = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: ${(props: IRootProps) => (props.leftValue ? props.leftValue : '530px')};
  top: ${(props: IRootProps) => (props.topValue ? props.topValue : '230px')};
  z-index: 100;
`

export const PopupContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 325px;
  min-height: 200px;
  flex-grow: 0;
  margin: 50px 9px 26px 0px;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  z-index: 100;
`

export const Title = styled.div`
  width: calc(100% - 60px);
  padding: 22px 30px 18px 30px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const DescriptionContainer = styled.div`
  width: calc(100% - 60px);
  padding: 0px 30px 14px 30px;
`

export const Description = styled.div`
  margin: 3px 0px 0px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(32, 64, 120, 0.5);
`

export const TopOptionsContainer = styled.div`
  padding: 10px 0px 10px 0px;
`

export const Divider = styled.div`
  width: calc(100% - 54px);
  height: 1px;
  margin: 0px 27px 0px 27px;
  background-color: rgba(32, 64, 120, 0.2);
`

export const BottomOptionsContainer = styled.div`
  padding: 10px 0px 10px 0px;
`

export const OptionContainer = styled.div`
  width: calc(100% - 60px);
  height: 50px;
  padding: 0px 30px 0px 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
`

export const OptionIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  margin: 0px 23px 0px 0px;
`

export const OptionText = styled.div`
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
`